<template>
  <div id="app">
    <BarcodeScanner ref="scanner" />
  </div>
</template>

<script>
import BarcodeScanner from './components/BarcodeScanner.vue'

export default {
  name: 'App',
  components: {
    BarcodeScanner
  },
  mounted() {
    window.app = this;
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 20px;
  padding: 0 15px;
}

.logo {
  max-width: 100px;
  margin-bottom: 10px;
}

h1 {
  font-size: 1.8em;
  margin-bottom: 20px;
}
</style>
